export const fetchBusinessRules = async (token, dispatch) => {
  const requestURL = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/business_rules/business_rules`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });
  try {
    const data = await fetch(requestURL, {
      method: 'GET',
      headers,
    });

    if (!data.ok) {
      const message = `Business Rules Fetch Data Not Okay: ${data?.status}`;
      const errorType = 'fetchBusinessRules';
      const errorCode = data.status;
      return [];
    }

    const response = await data.json();
    // console.log('fetchBusinessRules - response: ', response); // eslint-disable-line no-console
    return response;
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = 'fetchBusinessRules';
    const errorCode = isInternalError ? 500 : error.errorCode;
    return null;
  }
};
